import React, { useContext, useEffect, useState } from 'react'
import style from '../styles/register.module.css'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify';
import Loading from '../components/Loading';
import StateContext from '../context/state/StateContext';
import UserContext from '../context/user/UserContext';
import axios from 'axios';

const AdminRegister = () => {

    // admin register herer 
    const { user, verifyUser, user_verified } = useContext(UserContext)
    const { setLoading } = useContext(StateContext)
    const [select, setSelect] = useState('');
    const [formData, setFormData] = useState({ username: "", name: "", email: "", phone: '', password: "" });
    const [drop, setDrop] = useState(false);
    const [error, setError] = useState('');
    const [company, setCompany] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);

    const navigate = useNavigate();

    const token = localStorage.getItem("token")

    useEffect(() => {
        verifyUser()
        if (user_verified) {
            if (!token || user.verified == false) {
                navigate('/')
            }
        }
    }, [verifyUser, token, user_verified])


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading({ open: true, text: 'Creating' })
            const response = await fetch(process.env.REACT_APP_API_URL + "api/auth/create-super-user",
                {
                    method: 'POST',
                    headers: {
                        'Content-type': "application/json",
                    },
                    body: JSON.stringify({role: 'admin', username: formData.username, name: formData.name, email: formData.email, phone: formData.phone, password: formData.password})
                })

            const json = await response.json();
            if (json.success) {
                console.log("Successfully Created");
                toast.success("SuccessFully Created You are under Verification")
            } else {
                // setError(json.error || json.message || json.message[0].msg)
                if(json.error){
                    setError(json.error)
                }else{
                    setError(json.message[0].msg);
                }
            }


        } catch (error) {
            console.log(error);
            setError("Internal Server Error")
            console.log("Some Thing Went wrong");
        } finally {
            setLoading({ open: false, text: '' })
        }
    }


    return (
        <>
            <div className={`container-fluid ${style.register} py-4`}>
                <div className="row h-100">
                    <div className="col-lg-7 col-12 d-flex justify-content-center align-items-center flex-column h-100">
                        <h5 className={`${style.signin} mt-3`}>Go to<Link to="/dashboard"> Dashboard</Link></h5>
                        <div className={`container-fluid ${style.box}`}>
                            <div className="row">
                                <div className="col-lg-12">
                                    <h1 className="text-center">Register</h1>
                                    <div className={style.formstart}>
                                        <Loading />
                                        <form className={style.signup_form} onSubmit={handleSubmit}>
                                            <div className={style.inputField}>
                                                <i className='bx bx-user'></i>
                                                <input type="text" id="username" name='username' onChange={handleChange} className="" placeholder="Username" required />
                                            </div>
                                            <div className={style.inputField}>
                                                <i className='bx bx-user'></i>
                                                <input type="text" id="name" name='name' onChange={handleChange} className="" placeholder={company ? "Company Name" : "Full Name"} required />
                                            </div>
                                            <div className={style.inputField}>
                                                <i className='bx bx-envelope' ></i>
                                                <input type="email" id="email" name='email' onChange={handleChange} className="" placeholder="Email" required />
                                            </div>
                                            <div className={style.inputField}>
                                                <i className='bx bx-phone' ></i>
                                                <input type="text" id="phone" name='phone' onChange={handleChange} className="" maxLength={10} placeholder="Phone" required pattern="[0-9]{10}" />
                                            </div>
                                            <div className={`${style.inputField} mb-0`}>
                                                <i className='bx bx-lock-alt' ></i>
                                                <input type={passwordVisible ? "text" : "password"} id="password" name='password' onChange={handleChange} placeholder="Password" className="mb-0" required />
                                                <p style={{ cursor: "pointer" }} onClick={() => setPasswordVisible(!passwordVisible)}>{passwordVisible ? <i class="fa-regular fa-eye-slash"></i> : <i class="fa-regular fa-eye"></i>}</p>
                                            </div>
                                            <p style={{ color: "red", marginBottom: "0px" }}>{error}</p>
                                            <button type="submit" className={`"btn btn-block" ${style.bttn1}`} >Register</button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12"></div>
                </div>

            </div>
        </>
    )
}

export default AdminRegister;